import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-theme-bar-settings',
  standalone: true,
  imports: [NgClass],
  templateUrl: './theme-bar-settings.component.html',
  styleUrl: './theme-bar-settings.component.css'
})
export class ThemeBarSettingsComponent {
  @Input() currentTab = '';
  @Output() navigateTab: EventEmitter<string> = new EventEmitter<string>();
  constructor(private router: Router) {}
  // navigateTo(route: string) {
  //   this.router.navigate([`/${route}`]).catch((err) => {
  //     console.error(`Navigation to ${route} failed:`, err);
  //   });
  // }
  isActive(route: string): boolean {
    return this.router.url === `/${route}`;
  }
  setTab(currentTab: string) {
    // this.selectedTab = currentTab;
    this.navigateTab.emit(currentTab);
  }
}

